import { render, staticRenderFns } from "./addressbook.vue?vue&type=template&id=073865f5&scoped=true&"
import script from "./addressbook.vue?vue&type=script&lang=js&"
export * from "./addressbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073865f5",
  null
  
)

export default component.exports